import _styled5 from "styled-components";
import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import Symbol from '../symbol/Symbol';
import { AccordionItemSkeleton as ItemSkeleton, AccordionSkeleton as Skeleton } from './Accordion.skeleton';
import * as styles from './Accordion.style';
import { ICON_MINUS, ICON_PLUS } from '../../icons';
export const AccordionItemSkeleton = ItemSkeleton;
export const AccordionSkeleton = Skeleton;
const AccordionItem = _ref => {
  let {
    id,
    title,
    children,
    expanded = false,
    onTitleClick,
    ...rest
  } = _ref;
  const onTitleClickHandler = () => onTitleClick(id);
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({}, rest, {
    $_css: styles.item
  }), /*#__PURE__*/React.createElement(_StyledDiv2, {
    onClick: onTitleClickHandler,
    $_css2: styles.itemTitleWrapper
  }, /*#__PURE__*/React.createElement(_StyledDiv3, {
    dangerouslySetInnerHTML: {
      __html: title
    },
    "data-ref": "title",
    $_css3: styles.itemTitle
  }), /*#__PURE__*/React.createElement(_StyledDiv4, {
    $_css4: styles.itemTitleIcon
  }, /*#__PURE__*/React.createElement(Symbol, {
    path: expanded ? ICON_MINUS : ICON_PLUS,
    size: 24
  }))), expanded ? children : null);
};
const AccordionItemContent = _ref2 => {
  let {
    children,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(_StyledDiv5, _extends({
    "data-ref": "content"
  }, rest, {
    $_css5: styles.itemContent
  }), children);
};
export const Accordion = _ref3 => {
  let {
    children,
    ...rest
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", rest, children);
};
Accordion.Item = AccordionItem;
Accordion.ItemContent = AccordionItemContent;
export default Accordion;
var _StyledDiv = _styled("div").withConfig({
  displayName: "Accordion___StyledDiv",
  componentId: "sc-1w716bf-0"
})(["", ""], p => p.$_css);
var _StyledDiv2 = _styled("div").withConfig({
  displayName: "Accordion___StyledDiv2",
  componentId: "sc-1w716bf-1"
})(["", ""], p => p.$_css2);
var _StyledDiv3 = _styled("div").withConfig({
  displayName: "Accordion___StyledDiv3",
  componentId: "sc-1w716bf-2"
})(["", ""], p => p.$_css3);
var _StyledDiv4 = _styled("div").withConfig({
  displayName: "Accordion___StyledDiv4",
  componentId: "sc-1w716bf-3"
})(["", ""], p => p.$_css4);
var _StyledDiv5 = _styled("div").withConfig({
  displayName: "Accordion___StyledDiv5",
  componentId: "sc-1w716bf-4"
})(["", ""], p => p.$_css5);
//# sourceMappingURL=Accordion.js.map